import { render } from "./CreateUserRole.vue?vue&type=template&id=a72c78d2&scoped=true"
import script from "./CreateUserRole.vue?vue&type=script&lang=js"
export * from "./CreateUserRole.vue?vue&type=script&lang=js"

import "./CreateUserRole.vue?vue&type=style&index=0&id=a72c78d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72c78d2"]])

export default __exports__